export const devices = [
  {
    name: "iPhone 8",
    width: 414,
    height: 736,
  },
  {
    name: "iPhone X",
    width: 375,
    height: 812,
  },
  {
    name: "iPad",
    width: 768,
    height: 1024,
  },
];
